import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '@app/core/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    if (route.queryParamMap.has('token')) {
      this.authService.loginToolbox(route.queryParamMap.get('token'));
      return false;
    } else {
      if (
        route.queryParamMap.has('ticket') &&
        !route.queryParamMap.get('ticket').startsWith('ST-')
      ) {
        return this.authService.isTicketValid(route.queryParamMap.get('ticket')).then((result) => {
          if (!result) {
            this.authService.login();
          }

          return result;
        });
      } else if (
        route.queryParamMap.has('ticket') &&
        route.queryParamMap.get('ticket').startsWith('ST-')
      ) {
        return this.authService
          .isTicketValidToolbox(route.queryParamMap.get('ticket'))
          .then((result) => {
            if (!result) {
              this.authService.login();
            }

            return result;
          });
      }
    }

    const encryptedJwt = route.queryParams.ticket;
    return this.authService.jwtIsMissing(encryptedJwt);
  }
}
